<template>
  <StateAnalysis
    title="疲劳评价报告"
    report="plReportHistories"
  ></StateAnalysis>
</template>

<script>
import StateAnalysis from "./state.vue";
export default {
  components: {
    StateAnalysis,
  },
  computed: {},
  methods: {},
};
</script>

<style >
</style>